import { useState, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// hooks
import { useAppStateValue } from '../state/StateContext';

import { Loader } from '../components/Loader';
import { PATH_AUTH } from '../routes/paths';


// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const [{ isUserLogged, isStateInitialized }] = useAppStateValue();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isStateInitialized) {
    return <Loader />;
  }

  if (!isUserLogged) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    return <Navigate to={PATH_AUTH.root} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
